import {useEffect, useState} from "react";
import {Bounce, toast} from "react-toastify";
import {getEquipments} from "../../services/Administrative/equipmentService";


export const useGetEquipments = ({ filters = {} }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [equipments, setEquipments] = useState<any>([]);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    const addEquipmentLocally = (newEquipment: any) => {

        const transformedEquipment = {
            PLANTA: newEquipment.plantUniqueCode,
            CLIENTE: newEquipment.clientUniqueCode,
            DOSIFICADOR: newEquipment.dispenserUniqueCode,
            ADITIVO: newEquipment.additiveUniqueCode,
            ID: newEquipment.id
        }

        setEquipments((prevEquipments:any) => [...prevEquipments, transformedEquipment]);
    };

    const updateEquipmentLocally = (updatedEquipment: any) => {
        const transformedEquipment = {
            PLANTA: updatedEquipment.plantUniqueCode,
            CLIENTE: updatedEquipment.clientUniqueCode,
            DOSIFICADOR: updatedEquipment.dispenserUniqueCode,
            ADITIVO: updatedEquipment.additiveUniqueCode,
            ID: updatedEquipment.id
        }

        setEquipments((prevEquipments:any) => {
            return prevEquipments.map((equipment: any) =>
                equipment.ID === transformedEquipment.ID
                    ? transformedEquipment
                    : equipment
            );
        });
    }

    useEffect(() => {
        const fetchEquimpents = async () => {
            try {
                setIsLoading(true);
                const response:any = await getEquipments(page, filters);
                setEquipments(response.equipments);
                setPage(response.page);
                setTotalPages(response.totalPages);
            } catch (error:any) {
                if (error.response) {
                    if (error.response.status === 404) {
                        toast.warning(
                            `${error.response.data.message}. Por favor, verifique o limpie los filtros`,
                            {
                                position: 'top-right',
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false,
                                theme: 'colored',
                                transition: Bounce,
                            }
                        );
                    } else {
                        toast.error("Error al obtener los equipos.", {
                            position: 'top-right',
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false,
                            theme: 'colored',
                            transition: Bounce,
                        });
                    }
                } else {
                    toast.error("Error al obtener los equipos.", {
                        position: 'top-right',
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        theme: 'colored',
                        transition: Bounce,
                    });
                }
            }
            finally {
                setTimeout(() => {setIsLoading(false)}, 600)
            }
        };
        fetchEquimpents();
    }, [page, filters]);

    return { equipments, totalPages , isLoading, page, setPage, addEquipmentLocally, updateEquipmentLocally };
};
